/**
 * Black scrolling marquee that sits below the hero on the homepage.
 * Uses CSS animation (the native HTML <marquee> tag is deprecated).
 * Speed matches the classic IE/Edge `scrollamount="6"` behavior
 * (~70 pixels per second).
 */
export default function MarqueeBanner() {
    const message =
        "✨  Our focus is on uplifting diverse talent in food or hospitality with a unique story.  ✨  Amplifying Underrepresented Voices in Food & Hospitality  ✨";

    return (
        <div
            className="w-full overflow-hidden bg-black text-white py-3"
            data-testid="marquee-banner"
            role="marquee"
            aria-label={message}
        >
            <div className="marquee-track font-sofia text-base md:text-lg tracking-wide whitespace-nowrap">
                <span className="marquee-content px-8">{message}</span>
                <span className="marquee-content px-8" aria-hidden="true">
                    {message}
                </span>
                <span className="marquee-content px-8" aria-hidden="true">
                    {message}
                </span>
            </div>
        </div>
    );
}
